import type { NavigationGuardNext } from "vue-router";
import { useToast } from "primevue";
import { type ROLE, UserRoles } from "@/types";


export default async function requireAdmin({
  next,
}: {
  next: NavigationGuardNext;
}) {

  const toast = useToast();


  const userString = localStorage.getItem("user");

  if (!userString) {
    return next({
      name: "login"
    });
  }

  const user = JSON.parse(userString);

  const admin = user.roles.find(
    (role: ROLE) => role.roleName === UserRoles.CARBON_ACCOUNTING_ADMIN ||
      role.roleName === UserRoles.BONO_ACCOUNT_MANAGER ||
      role.roleName === UserRoles.BONO_SUPER_ADMIN
  );


  if (!admin) {
    toast.add({
      severity: "error",
      summary: "Unauthorized",
      detail: 'You are not authorised to access this area.',
      life: 3000
    });
    return next({
      name: "home",
    });
  }
  return next();
}
